<template>
  <NewBsBox
    :bs="{
      size,
      lineHeight: 0,
    }"
    v-bind="$attrs"
    role="img"
  >
    <svg
      :class="outerCls"
      x="0px"
      y="0px"
      viewBox="0 0 52 52"
    >
      <!--
          @slot
          @ignore
      -->
      <slot name="circleBefore">
        <circle
          :cx="CircleX"
          :cy="CircleX"
          :class="beforeCircleCls"
          :r="CircleRadius"
          slot-name="circleBefore"
        />
      </slot>
      <circle
        :cx="CircleX"
        :cy="CircleX"
        :class="mergedInnerCls"
        :style="innerStyle"
        :r="CircleRadius"
      />
      <!--
          @slot
          @ignore
      -->

      <slot name="circleAfter" />
    </svg>
  </NewBsBox>
</template>

<script lang="tsx">
  import {
    defineComponent, PropType, computed, inject,
  } from 'vue'
  import businessTheme from '@xhs/yam-beer/theme/businessTheme'
  import NewBsBox from '@xhs/yam-beer/cmp/primitive/NewBsBox'
  import { BeerStyleObj } from '@xhs/yam-beer/core'
  import { BeerCls } from '../../../core/ds/index.js'

  const BaseCircle = {
    strokeWidth: 3,
    strokeMiterlimit: 10,
    fill: 'transparent',
  }

  export const CircleRadius = 24
  const CircleX = 26

  /**
   * 圈圈图标组件图标
   */
  export default defineComponent({
    name: 'BaseSpinner',
    components: {
      NewBsBox,
    },
    props: {
      /**
       * 大小
       */
      size: {
        type: [String, Number] as PropType<string | number>,
        default: 30,
      },
      /**
       * 圈圈颜色
       */
      color: {
        type: String as PropType<string>,
        default: 'brand',
      },
      /**
       * @ignore
       */
      outerCls: {
        type: String as PropType<string>,
        default: '',
      },
      /**
       * @ignore
       */
      innerCls: {
        type: String as PropType<string>,
        default: '',
      },
      /**
       * @ignore
       */
      innerStyle: {
        type: Object as PropType<BeerStyleObj>,
        default: () => ({}),
      },
    },
    setup(props) {
      const theme = inject('theme', businessTheme)
      const beforeCircleCls = computed(() => BeerCls({
        ...BaseCircle,
        stroke: '#eef1f8',
      }))

      const mergedInnerCls = computed(() => [
        BeerCls({
          ...BaseCircle,
          strokeLinecap: 'round',
          stroke: props.color,
        }, {
          theme,
          ...props,
        }),
        props.innerCls,
      ])

      return {
        CircleX,
        CircleRadius,
        beforeCircleCls,
        mergedInnerCls,
      }
    },
  })
</script>
